import { Image, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { EventType } from 'hooks/events'
import { generateDateTerm } from 'libs'
import { FC } from 'react'
import styled from 'styled-components'

import { CustomerRankSection } from './parts/CustomerRankSection'
import { DateTermSection } from './parts/DateTermSection'
import { OwnerNameSection } from './parts/OwnerNameSection'

type Props = {
  event: EventType
}

export const LimitedEventInformation: FC<Props> = ({ event }) => {
  const { xs } = useBreakpoint()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: xs ? 'column' : 'row',
        gap: '24px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: xs ? '16px' : '40px',
          flex: 1,
        }}
      >
        <Image
          style={{ objectFit: 'cover' }}
          width="100%"
          height={xs ? '268px' : '490px'}
          src={event.main_event_image_url}
          loading="lazy"
          preview={false}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            paddingBottom: '20px',
            padding: xs ? '0px 16px' : '0px',
          }}
        >
          <CustomerRankSection customerRank={event.customer_rank} />
          <Typography.Text
            style={{
              fontSize: xs ? '22px' : '32px',
              lineHeight: 1.5,
              color: colors.primary,
            }}
          >
            {event.title}
          </Typography.Text>
          <Typography.Text
            style={{
              fontSize: xs ? '20px' : '28px',
              paddingBottom: xs ? 8 : 20,
              lineHeight: 1,
              color: colors.grey65,
            }}
          >
            {generateDateTerm({
              start: event.start_at,
              end: event.end_at,
              format: 'YYYY年M月D日',
              formatExceptYear: 'M月D日',
              connectingText: '-',
            })}
          </Typography.Text>
          <div style={{ position: 'relative' }}>
            <StyledTypography
              style={{
                fontSize: '14px',
                lineHeight: 1.5,
                color: colors.black,
                overflow: 'hidden',
                fontWeight: 'normal',
                position: 'absolute',
                width: '100%',
              }}
              ellipsis={{ rows: 1 }}
            >
              {event.description_teaser}
            </StyledTypography>
          </div>
        </div>
      </div>
      {!xs && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: xs ? '16px' : '28px',
            width: '262px',
            padding: xs ? '0px 16px' : '0px',
          }}
        >
          <OwnerNameSection
            ownerId={event.owner.id}
            ownerName={event.owner.name}
          />
          <DateTermSection startAt={event.start_at} endAt={event.end_at} />
        </div>
      )}
    </div>
  )
}

const StyledTypography = styled(Typography.Title)`
  position: relative;
  :before {
    content: '';
    position: absolute;
    border-style: none;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 21px;
    background: linear-gradient(rgba(255, 255, 255, 0) 0, #fff 21px);
  }
`
